import Header from "../components/Header";
import Filters from "../components/Filters";
import Main from "../components/Main";
import React, {useEffect} from "react";
import Footer from "./Footer";
import ReactGA from "react-ga4";
import {useLocation} from "react-router-dom";

interface ToolProps {
  displayValue: number;
  setDisplayValue: (val: number) => void;
  centersCheck: boolean;
  setCentersCheck: (val: boolean) => void;
  clear: boolean;
  setClear: (val: boolean) => void;
  clearClickable: boolean;
}
// interface ToolProps {
//   displayValue: number;
// }
const Tool: React.FC<ToolProps> = ({
  displayValue,
  setDisplayValue,
  centersCheck,
  setCentersCheck,
  clear,
  setClear,
  clearClickable,
}): JSX.Element => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return (
    <div className="bg-white flex flex-col min-h-screen overflow-visible">
      <Header />
      <div className="flex-grow">
        <div className="sticky top-4 z-[1000] ">
          <div className="hidden xl:block">
            <Filters
              displayValue={displayValue}
              setCentersCheck={setCentersCheck}
              map={true}
              comparator={"None"}
            />
          </div>
        </div>
        <br></br>
        <Main
          setDisplayValue={setDisplayValue}
          displayValue={displayValue}
          centersCheck={centersCheck}
          setCentersCheck={setCentersCheck}
          clear={clear}
          setClear={setClear}
          clearClickable={clearClickable}
        />
      </div>
      <Footer />
    </div>
  );
};

export default Tool;
